import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createWidget } from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';
import { TypeformDiv } from './Typeform.styles';
/**
 *
 * Themeable Typeform component that allows the user to embed a generic typeform in any container.
 *
 * Example usage:
 *
 *```js
 * import { Typeform } from '@minerva-analytics/pantheon';
 *
 * <Typeform formID='abcd123' parameters={parameters} />
 * ```
 *
 */

export var Typeform = function Typeform(props) {
  var container = useRef();
  useEffect(function () {
    createWidget("" + props.formID, {
      container: container.current,
      hidden: props.parameters
    });
  }, []);
  return /*#__PURE__*/React.createElement(TypeformDiv, {
    ref: container,
    "data-transparency": "100"
  });
};
Typeform.propTypes = {
  /** Form ID of the typeform to render */
  formID: PropTypes.string,

  /** Object of key:value pairs to append to the typeform URL */
  parameters: PropTypes.object
};
export default Typeform;